import translations from './translations'

translations.add('pt', {
    description: 'Entre em contacto com a loja do comerciante para resolver este problema',
    close: 'FECHAR'
})
